require('./app-menu');
require('./home-slider');
require('./home-video-modal');
// require('./home-splash');
require('./news-masonry');
require('./contact-boxes');
require('./director-info-modal');
require('./director-work-hover');
require('./director-hover');
require('./director-gallery');
require('./career-modal');
require('./video-modal');
// require('./player-center');
require('./post-video-hover');
require('./instafeed');
require('./resize');
require('./preview-player');
require('./youtube-container');

